export default "__VITE_ASSET__DqWeJ_rv__"